import { keyBy } from "lodash";

import { RequestAction } from "store/entities/actions";
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { ApplicationsActionNames as ApplicationsFeaturesActionNames } from "store/features/applications/actions";
import { IActionWithPayload } from "store/helper";

import { ApplicationsAction, ApplicationsActionNames } from "./actions";
import { IApplication } from "./interfaces";

export type IApplicationsState = {
  installed: Record<string, IApplication>;
  private: Record<string, IApplication>;
  inReview: Record<string, IApplication>;
};

export const initialState: IApplicationsState = {
  installed: {},
  private: {},
  inReview: {},
};

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const applicationsReducer = (state: IApplicationsState = initialState, action: ApplicationsAction) => {
  switch (action.type) {
    case ApplicationsActionNames.INSTALLED_APPS[RequestAction.SUCCESS]: {
      const { payload } = action as IActionWithPayload<string, IApplication[]>;

      return {
        ...state,
        installed: keyBy(payload, v => v.id),
      };
    }

    case ApplicationsActionNames.PRIVATE_APPS[RequestAction.SUCCESS]: {
      const { payload } = action as IActionWithPayload<string, IApplication[]>;

      return {
        ...state,
        private: keyBy(payload, v => v.id),
      };
    }

    case ApplicationsActionNames.IN_REVIEW_APPS[RequestAction.SUCCESS]: {
      const { payload } = action as IActionWithPayload<string, IApplication[]>;

      return {
        ...state,
        inReview: keyBy(payload, v => v.id),
      };
    }

    case ApplicationsFeaturesActionNames.INSTALL_APPLICATION_SUCCESSFUL: {
      const { payload } = action as IActionWithPayload<string, IApplication>;

      return {
        ...state,
        installed: {
          ...state.installed,
          [payload?.id]: payload,
        },
      };
    }

    case ApplicationsFeaturesActionNames.UNINSTALL_APPLICATION_SUCCESSFUL: {
      const { payload } = action as IActionWithPayload<string, IApplication>;

      // eslint-disable-next-line @typescript-eslint/naming-convention, @typescript-eslint/no-unused-vars
      const { [payload?.id]: _, ...filteredInstalled } = state.installed;

      return {
        ...state,
        installed: {
          ...filteredInstalled,
        },
      };
    }

    default:
      return state;
  }
};
